const tracking = require('../../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/baggage_tracking').getInstance();
const baggageCollectionBuilder = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/builders/baggages').getInstance();
const TRACKING_NAME = 'baggage-widget';

const CTA = {
    click: 'click',
    change: 'change',
};

const trackOnCtaClick = function(name = TRACKING_NAME) {
    const primeInfo = this.getPrimeInfo();
    const {isPrimeView, isPrimeUser} = primeInfo;
    const baggagePieces = this.getBaggageSelectedPieces();
    const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
        = baggageCollectionBuilder.getMerchandisingDiscountInfo();
    const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
    return {
        name: name,
        click: baggagePieces > 0 ? CTA.change: CTA.click,
        bags: baggagePieces,
        auto: +this.autoSelectionAvailable,
        pax: this.getPaxCount(),
        prime: isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
        maxdsc: tracking.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
        sav: Math.floor(this.getPrimeSavedAmount()),
        sce: this.isCheckedBagsOneClickInScope ? 'oc' : 'dc',
    };
};
const track = {
    onLoad: function() {
        const legsWithABagIncludedAndNoPossibilityToAddABag = Odigeo._.size(this.getPassengerIncludedAndNoSelectableRows(0));
        const legsWhereYouCanAddABag = Odigeo._.size(this.getPassengerSelectableRows(0));
        const legsWithABagIncludedAndPossibilityToAddABag = Odigeo._.size(this.getPassengerIncludedAndSelectableRows(0));
        const legsWithoutABagIncludedAndWithPossibilityToAddABag = legsWhereYouCanAddABag - legsWithABagIncludedAndPossibilityToAddABag;
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = this.getPrimeInfo();
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        return {
            name: TRACKING_NAME,
            loaded: {
                legsWithoutABagIncludedAndWithPossibilityToAddABag,
                legsWithABagIncludedAndNoPossibilityToAddABag,
                legsWithABagIncludedAndPossibilityToAddABag,
            },
            auto: +this.autoSelectionAvailable,
            pax: this.getPaxCount(),
            prime: isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
            maxdsc: tracking.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            sce: this.isCheckedBagsOneClickInScope ? 'oc' : 'dc',
        };
    },
    onOpen: trackOnCtaClick,
    onClose: trackOnCtaClick,
    onConfirm: trackOnCtaClick,
    onSelectOneClick() {
        return trackOnCtaClick.call(this, 'baggage-option');
    },
    onLoadMoreClick() {
        return trackOnCtaClick.call(this);
    },
};

export default {
    getTrackingData(event) {
        return {
            tracking,
            params: track[event].call(this),
        };
    },
};
